import {
  SiApplepodcasts,
  SiBluesky,
  SiFacebook,
  SiInstagram,
  SiSpotify,
  SiTiktok,
  SiX,
  SiYoutube,
} from "@icons-pack/react-simple-icons";
import { GlobeAltIcon } from "@heroicons/react/24/outline";
import type { SocialLink } from "@/db/schema";

export const SOCIAL_PLATFORMS = [
  {
    value: "applepodcasts" as const,
    label: "Apple Podcasts",
    icon: SiApplepodcasts,
  },
  { value: "bluesky" as const, label: "Bluesky", icon: SiBluesky },
  { value: "facebook" as const, label: "Facebook", icon: SiFacebook },
  { value: "instagram" as const, label: "Instagram", icon: SiInstagram },
  { value: "linkedin" as const, label: "LinkedIn", icon: GlobeAltIcon },
  { value: "spotify" as const, label: "Spotify", icon: SiSpotify },
  { value: "tiktok" as const, label: "TikTok", icon: SiTiktok },
  { value: "twitter" as const, label: "Twitter/X", icon: SiX },
  { value: "website" as const, label: "Website", icon: GlobeAltIcon },
  { value: "youtube" as const, label: "YouTube", icon: SiYoutube },
];

export function getSocialPlatformLabel(type: SocialLink["type"]): string {
  return SOCIAL_PLATFORMS.find((p) => p.value === type)?.label || type;
}

export function getSocialPlatformIcon(type: SocialLink["type"]) {
  return SOCIAL_PLATFORMS.find((p) => p.value === type)?.icon || GlobeAltIcon;
}
